<template>
<BaseModal :id="'static-duplication'" :title="title">
    <template v-slot:breadcrumb>
        <Breadcrumb :breadcrumb="breadcrumb" />
    </template>
    <template v-slot:content>
        <form class="col-12 p-0" @submit.prevent="form_submit_ext()">
            <FormDynamic :form_format="form_format" :form_data="form_data" :array_options="array_options" :for_update="false" />
            <CentralLiteButtons />
        </form>
    </template>
</BaseModal>
</template>

  
  
<script>
import FormResources from './form_resources'
import FormDynamic from '@/components/FormDynamic.vue'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal from '@/components/BaseModal'
import CentralLiteButtons from '@/components/CentralLiteButtons'

export default {
    name: "FormModal",
    props: [
        "title",
        "rest_api",
        "breadcrumb",
        "id"
    ],

    components: {
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralLiteButtons
    },

    data() {
        return {
            form_data: FormResources.form_data_duplication,
            form_format: FormResources.form_format_duplication,
            form_backup: { ...FormResources.form_data_duplication },
        }
    },

    methods: {       
        async form_submit_ext() {
          const res = await this.postingByPost('staffing_scenarios_duplicate_item', {...this.form_data, id: this.id}, 'static-duplication', false)
          this.$emit('unshift_object', res.data.data)
          this.form_data = { ...this.form_backup };
        }, 

    },

    mounted() {},
};
</script>
